import { Box } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { icons } from "../scenes/stack/environment/icons/iconExport";

const FavoriteTag = () => {
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "6px",
        padding: "3px",
        boxShadow: "0px 0px 1px 0px " + colors.warning_yellow_300_main_yellow,
        backgroundColor: colors.chip_favorites_enabled_bg,
      }}
    >
      <SvgToIcon
        IconLogo={icons.favoritesIcon}
        style={{
          width: "16px",
          height: "16px",
          color: colors.warning_yellow_300_main_yellow,
        }}
      />
    </Box>
  );
};

export default FavoriteTag;
